<template>
  <div>
    <!-- workspaceAccess === "false" → let user pick a workspace first -->
    <WorkSpaceList v-if="showWorkspaceList" />

    <!-- workspaceAccess === "true" (or not set) → show projects for the selected workspace -->
    <ProjectListWorkSpace v-else />
  </div>
</template>

<script>
import WorkSpaceList from "@/modules/settings/Organization/WorkSpace/WorkSpaceList.vue";
import ProjectListWorkSpace from "./ProjectListWorkSpace.vue";

export default {
  name: "WorkspaceEntryPoint",

  components: {
    WorkSpaceList,
    ProjectListWorkSpace,
  },

  created() {
    const access = localStorage.getItem("workspaceAccess");

    // workspaceAccess === "true" means the user already belongs to this workspace.
    // Skip the projects list and go straight to account selection.
    if (access === "true") {
      this.$router.replace("/showAccountForWorkspaces");
    }
    // workspaceAccess === "false" → showWorkspaceList renders WorkSpaceList below.
    // Any other value (null / undefined) → fall through to ProjectListWorkSpace.
  },

  data() {
    return {
      // Only show the workspace list when access is explicitly "false".
      // "true" is handled by the redirect in created(); we never reach the template for it.
      showWorkspaceList: localStorage.getItem("workspaceAccess") === "false",
    };
  },
};
</script>
